import { AuthHandler } from './auth';

// Pin the singleton on globalThis so that if this module ends up evaluated
// more than once in a page (host bundle + UMD/remote, dual chunk graphs,
// CJS/ESM interop, etc.) every evaluation reuses the same instance. Without
// this, callers that set the token on one copy never satisfy callers reading
// it from another, producing requests without an Authorization header.
const g = globalThis as { __cmx_authHandler?: AuthHandler };
const _authHandler: AuthHandler =
  g.__cmx_authHandler ?? (g.__cmx_authHandler = new AuthHandler());

export const setAuthHandler = (authHandler: AuthHandler) => {
  authHandler = authHandler;
};

export default _authHandler;
